import React from "react";
import { useSelector } from "react-redux";
import emitter from "../Game/Events/EventManager";
import { CHOOSE_TC, CHOOSE_SC, CHOOSE_EN, NEXT_PROGRESS } from "../Game/Events/Events";
import store from "../store/store.jsx";
import { dispatchChangeScene, dispatchChangeLang } from "../Game/reducers/sceneReducer";

const contentTC = {
  board0: {
    text: `
     前言，想知《最低工資條例》有關指定實習學員及工作經驗學員的豁免安排？快點挑戰一下這個遊戲！本遊戲提供的資料只作爲參考之用。對《最低工資條例》(第608章)的詮釋，應以法例原文為依歸。
     `,
    button: "下一頁 背景，請按 enter",
  },

  board1: {
    text: `
    背景，今天是一年一度的招聘日！
    你需要按公司想招聘的學生僱員類別
    (「實習學員」或「工作經驗學員」)，
    根據應徵者的履歷資料，安排合適的應徵者進入面試室。

    
    人事部已篩選了應徵者的履歷，你只需根據履歷表上餘下的資料，判斷應徵者是否適合進行面試。
    `,
    button: "下一頁 遊戲玩法，請按 enter",
  },

  board2: {
    text: `
    遊戲玩法。
    每次有兩個應徵者，人事部會表明想聘請的學生僱員類別，(「實習學員」或「工作經驗學員」。)有關的學生僱員條件而適合面試，然後按面試或出口。

    選對了，你會獲得 30 分。
    若選錯了，你會被扣 10 分。

    大家按入及記住重點，有助你完成任務。
    `,
    button: "下一頁 重點一，請按 enter",
  },
  board3: {
    text: `
    重點一。
    除非另有註明，《最低工資條例》適用於所有僱員。然而，對於與實習機構有僱傭關係的指定「實習學員」及「工作經驗學員」，條例設有豁免安排。

    修讀課程類別實習學員及工作經驗學員：條例指明的本地教育機構的全日制經評審課程，或居於香港，並修讀學位或更高程度的非本地學術資格的全日制教育課程
    `,
    button: "下一頁 重點二，請按 enter",
  },
  board4: {
    text: `
    重點二。    
    工作實習性質和限制。

    實習由教育機構安排或認可，
    屬課程必修或選修部份，
    年齡及工作實習期，
    沒有限制。
 
    工作經驗學員:
    不論是否由教育機構安排或認可，
    可與課程有關或無關，
    年齡及工作實習期有限制，
    未滿26歲，
    與僱主協議獲豁免學生僱用期，
    (最長59天，最多同一公曆年開始一段豁免期)
    `,
    button: "開始遊戲，請按  enter",
  },
};

const contentEN = {
  board0: {
    text: `
    Foreword: 
    Wanna know the exemption arrangement for the specified student interns and work experience students under the Minimum Wage Ordinance? Let's take the challenge and play the game!   
      
    The information provided in this game is for reference only. The interpretation of the Minimum Wage Ordinance (Cap.608) should be based on its original text.
`,
    button: "next page: background, press enter",
  },
  board1: {
    text: `
    Background:
    Today is the annual recruitment day! You need to select the right candidates to enter the interview room according to their resumes for the type of student employees being recruited by the company (either "Student Interns" or "Work Experience Students"). 
    
    The Human Resources Department (HR) has already screened through the candidates' resumes to ensure that all criteria except one fulfill the interview requirement. You only need to decide whether the candidate fits for interview with the remaining criterion on the resume.  
 `,
    button: "next page: game rules, press enter",
  },
  board2: {
    text: `
    Game Rules:
    Each round consists of two candidates. HR will indicate the type of student employees being recruited ("Student Interns" or "Work Experience Students"). Within the time limit, you need to decide whether the criterion on the resume satisfies the requirement of the student employee being recruited. If yes, click "Interview" and if no, click "Exit". 

    30 points scored for a right choice. 10 points deducted for a wrong choice. 

    Click and memorise Key Points to facilitate your completion of the mission.
    `,
    button: "next page: Key Point 1, press enter",
  },
  board3: {
    text: `     
      Key Point1:
      Kinds of programme enrolled Student Interns and Work Experience Students:

      full-time accredited programmes being provided by local
      education institutions specified in MWO; or

      residing in Hong Kong and enrolled in full-time education
      programmes for non-local academic qualification at
      degree or higher level

    `,
    button: "next page: Key Point 2",
  },
  board4: {
    text: `
    Key Point2
    Nature & Restriction of Internship

    Student Interns:

    arranged or endorsed by the education institutions.

    form a compulsory or elective component of the programmes.

    NO restriction on age & duration of internship.


    Work Experience Students:
    NOT necessarily be arranged or endorsed by the education institutions.

    NOT necessarily be curriculum-related.


    Restriction on age& duration of Internship.

    under the age of 26 years agree to a period of exempt student employment with employer (at most one period of up to 59 days in the same calendar year).
    `,
    button: "Game Start",
  },
};

const contentSC = {
  board0: {
    text: `前提，想知《最低工资条例》有关，指定学习学员及工作验学员的豁免安排？快点挑战一下这个游戏。
    
    本游戏的资料只作为参考用途。对《最低工资条例》(第608章)的诠释，应以法例原文为依归。`,
    button: "下一页 背景，请按 enter      ",
  },

  board1: {
    text: `背景，今天是一年一度的招聘日！你需要按公司想招聘的学生雇员类别(「实习学员」或「工作经验学员」)，根据应征者的履历资料，安排合适的应征者进入面试室。
    
    人事部已筛选了应征者的履历，确定除一项资料外，其他的条件均符合面试要求。你只需根据履历表上馀下的资料，判断应征者是否适合进行面试。
    `,
    button: "下一页 游戏玩法，请按 enter",
  },

  board2: {
    text: `
    游戏玩法。
    每次有两个应征者，人事部会表明想聘请的学生雇员类别，(「实习学员，或「工作经验学员」。)你须在限定时间内，根据应征者的履历资料，判断应征者是否符合有关的学生雇员条件而适合面试，然后按面试或出口。

    选对了，你会获得30分。若选错了，你会被扣10分。

    大家按入及记住重点，有助你完成任务。

    `,
    button: "下一页 重点一，请按 enter",
  },
  board3: {
    text: `
    重点一。
    除非另有注明，《最低工资条例》适用于所有雇员。然而，对于与实习机构有雇佣关系的指定「实习学员」及「工作经验学员」，条例设有豁免安排。

 
    修读课程类别实习学员及工作经验学员：条例指明的本地教育机构全日制经评审课程，或居于香港，并修读学位或更高程度的非本地学术资格的全日制教育课程。
    `,
    button: "下一页 重点二，请按 enter",
  },
  board4: {
    text: `
    重点二。    
    工作实习性质和限制。

    实习学员:
    实习由教育机构安排或认可；
    属课程必修或选修部份，
    年龄及工作实习期没有限制。
 
    工作经验学员：

    不论是否由教育机构安排或认可

    可与课程有关或无关

    年龄及工作实习期有限制，未满26岁，与雇主协议获豁免学生雇用期，最长59天，最多同一公历年开始一段豁免期
    `,
    button: "开始游戏，请按  enter",
  },
};

export default function Scene2Overlay() {
  const lang = useSelector((state) => state.currentScene.currentLang) || "TC";
  let currentContents;
  if (lang == "TC") {
    currentContents = contentTC;
  }

  if (lang == "SC") {
    currentContents = contentSC;
  }

  if (lang == "EN") {
    currentContents = contentEN;
  }

  const currentProgress = useSelector((state) => state.currentScene.progress);
  return (
    <div className="hidden">
      <ContentBoard progress={currentProgress} contents={currentContents} />
    </div>
  );
}

function ContentBoard(props) {
  const progress = props.progress;
  const content = props.contents["board" + progress];
  const text = content ? content.text : "to be added";
  const button = content ? content.button : "to be added";
  return (
    <div>
      <div tabIndex="1">{text}</div>
      <div
        tabIndex="2"
        onKeyDown={(e) => {
          if (e.keyCode == 13) {
            emitter.emit(NEXT_PROGRESS);
          }
        }}
      >
        {button}
      </div>
    </div>
  );
}
